import React, { useEffect, useState } from 'react'
import { Config } from '@chegg-wt/core/config'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import {
  getLocalStorageItem,
  LOCAL_STORAGE_KEYS,
  setLocalStorageItem,
} from '@chegg-wt/core/utils/localStorage'
import {
  MY_CITATION_PROJECT_LIST_TITLE,
  CITATION_LIST_NAME_LOWER_PLURAL,
} from '@chegg-wt/core/constants/citations'
import { Link } from '@chegg-ui/link'
import { useToggle } from '@chegg-wt/core/hooks/useToggle'
import { Icon as InfoIcon } from '../shared/ProjectMenu/styled'
import * as Styled from './styled'

const ProjectAlert = () => {
  const { value: isOpen, off, on } = useToggle()
  const [icon, setIcon] = useState<JSX.Element>()

  const target = Config.shouldOpenInNewTab ? '_blank' : null

  useEffect(() => {
    const wasVisited = getLocalStorageItem(LOCAL_STORAGE_KEYS.visitedFolder)
    if (!wasVisited) {
      setLocalStorageItem(LOCAL_STORAGE_KEYS.visitedFolder, 'true')
      on()
    }
  }, [])

  useEffect(() => {
    setIcon(
      <InfoIcon
        icon={publicAssetUrl('eb-exclamation-mark-blue.svg')}
        iconSize={isOpen ? '40px' : '20px'}
      />
    )
  }, [isOpen])
  return (
    <Styled.Border>
      {isOpen && <Styled.CloseButton name="clear" onClick={off} />}
      <Styled.Container>
        {icon}
        <Styled.Content>
          {isOpen && (
            <>
              <Styled.Header>
                <Styled.Bold>{MY_CITATION_PROJECT_LIST_TITLE}</Styled.Bold> has a new
                look!
              </Styled.Header>
              <Styled.P>
                It&#39;s still the place to see, share, and organize your{' '}
                {CITATION_LIST_NAME_LOWER_PLURAL}.
              </Styled.P>
            </>
          )}
          <Styled.P marginBottom="0px">
            Looking for grammar and plagiarism?
            <Styled.LinkToPapers>
              <Link href={Config.writingUrl} target={target}>
                Go to My papers
              </Link>
            </Styled.LinkToPapers>
          </Styled.P>
        </Styled.Content>
      </Styled.Container>
    </Styled.Border>
  )
}

export default ProjectAlert
